import { useMutation, useQuery } from "@tanstack/react-query";
import { api } from "api";
import { T_Api_Success_Res } from "./api.types";
import { PaymentAttemptDto, PaymentJobDto } from "dtos/payment.job.dto";

export const paymentJobService = {
  useGetJobsByLedger: (params: { ledger_id: string | undefined; application_id: string | undefined }) => {
    return useQuery({
      queryKey: ["payment-jobs", params.ledger_id, params.application_id],
      queryFn: async () => {
        const res = await api.get(`/payment-jobs`, { params });
        return res.data as T_Api_Success_Res<PaymentJobDto[]>;
      },
      enabled: !!params.ledger_id && !!params.application_id,
    });
  },

  useToggleDistributionJobLapse: () => {
    return useMutation({
      mutationKey: ["payment-jobs/lapse"],
      mutationFn: async ({ job_id }: { job_id: string }) => {
        return api.patch(`/payment-jobs/lapse/${job_id}`);
      },
    });
  },

  useResumeCreditorOutgoingJob: () => {
    return useMutation({
      mutationKey: ["payment-jobs/creditor-outgoing/resume"],
      mutationFn: async ({ payment_job_id, mode }: { payment_job_id: string; mode: "actual" | "virtual" }) => {
        return api.post(`/payment-jobs/creditor-outgoing/resume`, {
          payment_job_id,
          mode,
        });
      },
    });
  },

  useCancelAllApplicationPaymentJobs: () => {
    return useMutation({
      mutationKey: ["payment-jobs/application", "cancel-jobs"],
      mutationFn: async ({ application_id }: { application_id: string }) => {
        return api.post(`/payment-jobs/application/cancel-jobs`, { application_id });
      },
    });
  },

  useGetPaymentChargeAttempts: (params: { ledger_id: string | undefined; application_id: string | undefined }) => {
    return useQuery({
      queryKey: ["payment-jobs/charge-attempts", params.ledger_id, params.application_id],
      queryFn: async () => {
        const res = await api.get(`/payment-jobs/charge-attempts`, { params });
        return res.data as T_Api_Success_Res<PaymentAttemptDto[]>;
      },
      enabled: !!params.ledger_id && !!params.application_id,
    });
  },

  useGetJobsForPreview: (params: { application_id: string | undefined }) => {
    return useQuery({
      queryKey: ["payment-jobs/preview", params.application_id],
      queryFn: async () => {
        const res = await api.get(`/payment-jobs/preview`, { params });
        return res.data as T_Api_Success_Res<PaymentJobDto[]>;
      },
      enabled: !!params.application_id,
    });
  },

  useReschedulePaymentJob: () => {
    return useMutation({
      mutationKey: ["payment-jobs/application", "reschedule-jobs"],
      mutationFn: async ({ paymentJobId, customTime }: { paymentJobId: string; customTime?: Date | string }) => {
        return api.post(`/payment-jobs/reschedule-job`, { paymentJobId, customTime });
      },
    });
  },
};
